import React /*, { ReactNode }*/ from 'react';
import { Avatar, Box, Button, Container, Divider, IconButton, Stack, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
//import { ReactComponent as AISVG } from '../../assets/ai_star.svg';
import { setPublicPinClicked } from "../../features/dataProcessingSlice"
//import { showProfile } from '../../features/dialogSlice';
import CloseIcon from '@mui/icons-material/Close';
import EditIcon from '@mui/icons-material/Edit';
import AutoStoriesIcon from '@mui/icons-material/AutoStories';
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import FormatQuoteIcon from '@mui/icons-material/FormatQuote';
import RoomOutlinedIcon from '@mui/icons-material/RoomOutlined';
import SmsOutlinedIcon from '@mui/icons-material/SmsOutlined';
import { MessageProfile, PinChip } from '../MessageProfile';
import { SummarizedAIProfile } from "./SummarizedAIProfile"
import { Recommendations } from './Recommendations';
import { showProfile } from '../../features/dialogSlice';
import { useAuthProfile } from '../../app/hooks';
import BarChartIcon from '@mui/icons-material/BarChart';
import { selectChat } from '../../features/dialogSlice';

import { AccountPromotion } from '../iam/AccountPromotion';
import { useNavigate } from "react-router-dom";
import Paper from '@mui/material/Paper';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { useAuth } from 'react-oidc-context';
import { Condition, coonditionContext } from '../..';
import { SpeakButton } from '../../app/components/SpeakButton';


interface AIProfileProps {
    bottomSheetRef: any,
    profileToShow: any,
    //story: string
    //name: string
    //authStatus: any
    AIProfileSummary: any,
    //showAccountPromotion: boolean,
    showViewUserStoryAnalytics?: boolean,
    showMessageButton?: boolean,
    chatMode?: boolean
}

export const AIProfile: React.FC<AIProfileProps> = ({ bottomSheetRef, profileToShow, AIProfileSummary, showViewUserStoryAnalytics = true, showMessageButton = true, chatMode = false }) => {
    const { authStatus, profile: loggedInUserProfile, isLoading, isSuccess, isError, error, } = useAuthProfile()
    const isLoggedInUserProfile = loggedInUserProfile?.iam_id === profileToShow.iam_id
    const dispatch = useDispatch<any>();
    const chatState = useSelector((state: any) => state.dialog);
    const navigate = useNavigate()
    const auth = useAuth()
    const { condition, baseName } = React.useContext<Condition>(coonditionContext);

    // function editStory() {
    //     dispatch(showProfile({ isForced: true }))
    // }

    function closeProfile() {
        if (chatMode) {
            dispatch(selectChat())
        } else {
            dispatch(setPublicPinClicked(false))
        }
    }

    function scrollToSummary() {
        document.getElementById('summary')?.scrollIntoView({ behavior: 'smooth' })
        if (bottomSheetRef) {
            bottomSheetRef.bottomSheet?.current.snapTo(1000);
        }
    }

    function handleProfileClick() {
        if (authStatus == 'authenticated') {
            dispatch(showProfile({ isForced: true }))
        } else {
            navigate("/Signin")
        }
    }
    // function editStory() {
    //     dispatch(showProfile({ isForced: true }))
    // }
    const name = profileToShow.name_public
    const story = profileToShow.comment
    const AIRecommendations = AIProfileSummary.recommendations
    let haveAIRecommendations: boolean = (authStatus === 'authenticated' && isLoggedInUserProfile && AIRecommendations) ? Object.keys(AIRecommendations).length > 0 : false
    //console.log(profileToShow)
    //console.log(loggedInUserProfile)
    //{((authStatus === 'authenticated' && isLoggedInUserProfile && (AIRecommendations?.length ?? Object.keys(AIRecommendations[0]).length > 0))) ?
    //<Recommendations AIRecommendations={AIRecommendations} /> : null}
    return (

        <Stack sx={{ width: '100%', pb: 2 }} direction="column" gap={2} >
            <Box sx={{ pl: 2, pr: 2 }}>
            
                {authStatus == 'authenticated' || profileToShow.name_public != 'Guest'
                    ?
                    ((profileToShow.name_public != loggedInUserProfile?.name_public) || loggedInUserProfile.is_completed)
                        ?
                        <Stack direction="column" gap={2}>
                            {/* ── Profile Header Card ── */}
                            <Box sx={{
                                borderRadius: '16px',
                                overflow: 'hidden',
                                border: '1px solid rgba(164, 142, 233, 0.22)',
                                boxShadow: '0 2px 12px rgba(101, 110, 255, 0.08)',
                            }}>
                                {/* Gradient header */}
                                <Stack direction="row" alignItems="center" gap={1.5} sx={{
                                    background: 'linear-gradient(135deg, rgba(139,92,246,0.85) 0%, rgba(165,120,255,0.80) 100%)',
                                    px: 2, py: 1.5,
                                    boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.3)',
                                }}>
                                    <Avatar sx={{
                                        width: 44, height: 44,
                                        bgcolor: 'rgba(255,255,255,0.2)',
                                        fontSize: 17, fontWeight: 700, color: 'white',
                                        border: '2px solid rgba(255,255,255,0.3)',
                                        flexShrink: 0,
                                    }}>
                                        {name?.[0]?.toUpperCase() ?? '?'}
                                    </Avatar>
                                    <Stack direction="column" gap={0.25} sx={{ flex: 1, minWidth: 0 }}>
                                        <Stack direction="row" alignItems="center" gap={0.5}>
                                            <Typography sx={{ fontWeight: 700, color: 'white', fontSize: '0.95rem', lineHeight: 1.3 }}>
                                                {name}
                                            </Typography>
                                            {isLoggedInUserProfile && (
                                                <IconButton size="small"
                                                    onClick={() => dispatch(showProfile({ isForced: true, step: 3, singleScreen: true }))}
                                                    sx={{ ml: 'auto', p: 0.25, color: 'rgba(255,255,255,0.8)', '&:hover': { color: 'white', bgcolor: 'rgba(255,255,255,0.15)' } }}>
                                                    <EditIcon sx={{ fontSize: '1rem' }} />
                                                </IconButton>
                                            )}
                                        </Stack>
                                    </Stack>
                                </Stack>
                                {/* Body — badge, location, CTA */}
                                <Stack direction="column" gap={1} sx={{ px: 2, py: 1.5, backgroundColor: '#F7F6FF' }}>
                                    <Stack direction="row" gap={1} alignItems="center" sx={{ flexWrap: 'wrap' }}>
                                        <PinChip category="User" type={profileToShow.type} size="small" iconSizePx={16} sx={{ height: '24px', fontSize: '0.7rem' }} />
                                        {profileToShow.formattedsearchterm && (
                                            <Stack direction="row" alignItems="center" gap={0.5} sx={{ minWidth: 0 }}>
                                                <RoomOutlinedIcon sx={{ fontSize: 15, color: '#656EFF', flexShrink: 0 }} />
                                                <Typography variant="caption" sx={{ color: '#555', lineHeight: 1.3 }}>{profileToShow.formattedsearchterm}</Typography>
                                            </Stack>
                                        )}
                                    </Stack>
                                    {(showMessageButton && !isLoggedInUserProfile) && (
                                        <Button
                                            variant="contained"
                                            disableElevation
                                            startIcon={<SmsOutlinedIcon />}
                                            onClick={() => navigate({
                                                pathname: '/Conversations',
                                                search: new URLSearchParams({ directId: profileToShow.id, directNamePublic: profileToShow.name_public }).toString(),
                                            })}
                                            sx={{ mt: 0.5, borderRadius: 2, textTransform: 'none', fontWeight: 600, fontSize: '0.8rem', background: 'linear-gradient(135deg, #8B5CF6 0%, #7C3AED 100%)', color: 'white', boxShadow: '0 2px 8px rgba(139,92,246,0.25)', '&:hover': { background: 'linear-gradient(135deg, #7C3AED 0%, #6D28D9 100%)' } }}
                                        >
                                            Message
                                        </Button>
                                    )}
                                </Stack>
                            </Box>

                            {/* ── Story Section Card ── */}
                            <Box sx={{
                                p: 2, borderRadius: '12px',
                                backgroundColor: '#F7F6FF',
                                border: '1px solid #EEEDFF',
                            }}>
                                <Stack direction="row" alignItems="center" gap={1.5} sx={{ mb: 1.5 }}>
                                    <Box sx={{
                                        minWidth: 36, height: 36, borderRadius: '10px',
                                        background: 'linear-gradient(135deg, #EEEDFF 0%, #D4D2FF 100%)',
                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    }}>
                                        <AutoStoriesIcon sx={{ fontSize: 18, color: '#656EFF' }} />
                                    </Box>
                                    <Typography variant="body2" sx={{ fontWeight: 700, color: '#1a1a2e', flex: 1 }}>
                                        Story
                                    </Typography>
                                    {story && <SpeakButton label="Listen" text={story} />}
                                </Stack>
                                {story
                                    ? <Box sx={{
                                        position: 'relative',
                                        borderLeft: '3px solid rgba(101, 110, 255, 0.4)',
                                        pl: 2, py: 0.5,
                                        backgroundColor: 'rgba(255, 255, 255, 0.5)',
                                        borderRadius: 1,
                                    }}>
                                        <FormatQuoteIcon sx={{
                                            position: 'absolute', top: -4, left: 4,
                                            fontSize: 18, color: 'rgba(101, 110, 255, 0.3)',
                                            transform: 'scaleX(-1)',
                                        }} />
                                        <Typography variant="body2" sx={{ color: '#555', lineHeight: 1.6 }}>{story}</Typography>
                                    </Box>
                                    : <Box sx={{
                                        border: '1.5px dashed rgba(101, 110, 255, 0.2)',
                                        borderRadius: '10px', py: 2.5,
                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    }}>
                                        <Typography variant="body2" sx={{ color: '#bbb', fontStyle: 'italic' }}>No story shared yet</Typography>
                                    </Box>
                                }
                            </Box>

                            {haveAIRecommendations && <Recommendations AIRecommendations={AIRecommendations} />}

                            {/* ── Health Profile Section Card ── */}
                            <Box sx={{
                                p: 2, borderRadius: '12px',
                                backgroundColor: '#F7F6FF',
                                border: '1px solid #EEEDFF',
                                pb: 10,
                            }}>
                                <Stack direction="row" alignItems="center" gap={1.5} sx={{ mb: 1 }}>
                                    <Box sx={{
                                        minWidth: 36, height: 36, borderRadius: '10px',
                                        background: 'linear-gradient(135deg, #EEEDFF 0%, #D4D2FF 100%)',
                                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    }}>
                                        <LocalHospitalIcon sx={{ fontSize: 18, color: '#656EFF' }} />
                                    </Box>
                                    <Typography variant="body2" sx={{ fontWeight: 700, color: '#1a1a2e' }}>
                                        Health Profile
                                    </Typography>
                                </Stack>
                                <Box id="summary">
                                    <SummarizedAIProfile profileToShow={profileToShow} aiSummary={AIProfileSummary.ai_summary} loggedInUserprofileCoordinates={{ lat: loggedInUserProfile?.lat, lng: loggedInUserProfile?.lng }} chatMode={chatMode} />
                                </Box>
                            </Box>
                        </Stack>
                        :
                        <>
                            <MessageProfile hideUserAndLocationPinsForIncompleteProfile profile={profileToShow} showMessageButton={showMessageButton} onEdit={() => {
                                dispatch(showProfile({ isForced: true, step: 3, singleScreen: true, hideUserAndLocationPinsForIncompleteProfile: true }))
                            }} />
                            <Paper
                                onClick={handleProfileClick}
                                elevation={0}
                                sx={{
                                    width: '100%',
                                    borderRadius: 3,
                                    cursor: 'pointer',
                                    border: '1px solid #E8E4FF',
                                    backgroundColor: '#F5F3FF',
                                    boxShadow: '0 2px 8px rgba(101,110,255,0.08)',
                                    transition: 'all 0.15s ease',
                                    '&:hover': { backgroundColor: '#EDE9FF', borderColor: '#C5BEFF' },
                                }}
                            >
                                <Stack direction="column" gap={2} sx={{ p: 2.5 }}>
                                    <Stack direction="column" gap={0.5}>
                                        <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#1a1a2e', fontSize: 15 }}>
                                            Complete your profile
                                        </Typography>
                                        <Typography variant="body2" sx={{ color: '#555', lineHeight: 1.5 }}>
                                            Share your story to connect with others who understand your journey.
                                        </Typography>
                                    </Stack>
                                    <Stack direction="column" gap={1}>
                                        {[
                                            { label: "Find members with similar experiences" },
                                            { label: "Gain insights from the community" },
                                            { label: "Support others on their journey" },
                                        ].map(({ label }) => (
                                            <Stack key={label} direction="row" alignItems="center" gap={1}>
                                                <CheckCircleIcon sx={{ color: '#656EFF', fontSize: 18, flexShrink: 0 }} />
                                                <Typography variant="body2" sx={{ color: '#333' }}>
                                                    {label}
                                                </Typography>
                                            </Stack>
                                        ))}
                                    </Stack>
                                    <Button
                                        variant="contained"
                                        disableElevation
                                        sx={{ alignSelf: 'flex-start', backgroundColor: '#656EFF', borderRadius: 2, textTransform: 'none', fontWeight: 600, px: 2.5, boxShadow: '0 2px 8px rgba(101,110,255,0.25)' }}
                                        onClick={(e) => { e.stopPropagation(); handleProfileClick(); }}
                                    >
                                        Get started
                                    </Button>
                                </Stack>
                            </Paper>
                        </>
                    :
                    <AccountPromotion />
                }


            </Box>
        </Stack>

    )
}


